import DocPageLayout, { Section } from "@/components/DocPageLayout";

// Newest-first. Keep entries factual and dated.
const CHANGELOG = [
  {
    date: "Feb 12, 2026",
    version: "v2.10",
    changes: [
      "New: Combined shipping — vendors can set initial charge, per-additional-card, and max-per-package. Policy shows on every listing.",
      "New: Global footer with brand attribution across every page.",
      "Fix: badges on browse tiles no longer overflow — chips wrap or collapse to icons on mobile.",
      "New: mobile legend row above browse explaining the icon-only chips.",
    ],
  },
  {
    date: "Feb 12, 2026",
    version: "v2.9",
    changes: [
      "New: legal acknowledgment checkboxes required at signup, vendor upgrade/application, and Purchase Order open. Every acknowledgment is timestamped for audit.",
      "New: Terms of Service rewritten with 9-clause production language covering listing-service-only positioning, off-platform payments, no-liability, and dispute exclusion.",
    ],
  },
  {
    date: "Feb 12, 2026",
    version: "v2.8",
    changes: [
      "New: 'The Pack' community stats column on browse — live members / vendors / listings counts.",
    ],
  },
  {
    date: "Feb 12, 2026",
    version: "v2.7",
    changes: [
      "New: report an abusive or rule-breaking message — hover any incoming message, click the flag, add a required comment.",
      "New: FIRM warning banner in conversations tied to FIRM listings — clear notice that offers on FIRM cards are strike-worthy.",
    ],
  },
  {
    date: "Feb 12, 2026",
    version: "v2.6",
    changes: [
      "New: Like system — 👍 counter on every listing, batch-hydrated for signed-in users.",
      "New: Browse featured strip — Top Dog (most expensive), Just Listed (15 most recent, auto-scroll), Fan Favorites (top 8 most liked).",
    ],
  },
  {
    date: "Feb 12, 2026",
    version: "v2.5",
    changes: [
      "New: Seller typeahead autocomplete on the browse Seller filter. Case-insensitive prefix match, keyboard nav, tier/role chips inline.",
    ],
  },
  {
    date: "Feb 12, 2026",
    version: "v2.4",
    changes: [
      "New: Prev / Next listing navigation on the detail page. ← / → keyboard shortcuts supported.",
    ],
  },
  {
    date: "Feb 12, 2026",
    version: "v2.3",
    changes: [
      "New: Notification bell in the top nav — unread counter for PO updates and messages.",
    ],
  },
  {
    date: "Feb 12, 2026",
    version: "v2.2",
    changes: [
      "New: Strike / Standing system with 3-green-check status indicator on public profiles.",
      "New: 72-hour Purchase Order expiry timers.",
    ],
  },
  {
    date: "Feb 12, 2026",
    version: "v2.1",
    changes: [
      "New: Stripe vendor subscription — 30-day free trial then $49.99/year on your anniversary. Payment method required on file for both vendor paths. Founding Members exempt.",
      "New: Sales Vault + Super Admin role for site owners.",
      "New: Automated Vendor Tier system (1 → 2 → 3) based on confirmed sales and standing.",
    ],
  },
];

export default function Changelog() {
  return (
    <DocPageLayout
      subtitle="What's New"
      title="Changelog"
      intro="Every update to Hunt57, newest first. If a feature confused you, this page is where it was announced."
    >
      {CHANGELOG.map((entry) => (
        <Section key={entry.version} title={`${entry.version} — ${entry.date}`} id={entry.version.toLowerCase()}>
          <ul className="list-disc pl-5 space-y-1">
            {entry.changes.map((c, i) => <li key={i}>{c}</li>)}
          </ul>
        </Section>
      ))}
    </DocPageLayout>
  );
}
